var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27748 10.2225C2.61381 10.5589 3.14013 10.5894 3.511 10.3143L3.61726 10.2225L8 5.84021L12.3827 10.2225C12.7191 10.5589 13.2454 10.5894 13.6163 10.3143L13.7225 10.2225C14.0589 9.88619 14.0894 9.35987 13.8142 8.989L13.7225 8.88274L8.66989 3.83011C8.33355 3.49377 7.80724 3.4632 7.43636 3.73838L7.33011 3.83011L2.27748 8.88274C1.90751 9.25271 1.90751 9.85255 2.27748 10.2225Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowClose);
export default __webpack_public_path__ + "static/media/up-arrow-close.6c5f684ef2edff1d4034a2e96970ba53.svg";
export { ForwardRef as ReactComponent };